const log = console.log;

export class Logger {
  constructor(private readonly logEvents: boolean) {}

  logInfo = (...data: unknown[]) =>
    this.logEvents && log("ℹ️", "[Info]", ...data);

  logSuccess = (...data: unknown[]) =>
    this.logEvents && log("✅", "[Success]", ...data);

  logWarning = (...data: unknown[]) =>
    this.logEvents && log("🤔", "[Warning]", ...data);

  logError = (...data: unknown[]) =>
    this.logEvents && log("🚨", "[Error]", ...data);
}

export const logEvents =
  import.meta.env.VITE_APP_LOG_EVENTS &&
  JSON.parse(import.meta.env.VITE_APP_LOG_EVENTS);

export const logger = new Logger(logEvents);
